import { Injectable, inject, signal } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LibClient360Component } from '@libs/client';
import {
  ClientProfileOpener,
  ClientProfileOpenOptions,
} from '@libs/util-services';

/**
 * Implementação concreta do CLIENT_PROFILE_OPENER pro lessor app.
 *
 * Abre o novo `<lib-client-360>` (Onda 5) num modal full-screen — substitui
 * o legado `ClientModalInfoComponent`. Apresenta o perfil com KPIs, abas
 * (Tudo / Agendamentos / Dados) e action bar (Cobrar/Agendar/WhatsApp).
 */
@Injectable({ providedIn: 'root' })
export class LessorClientProfileOpener implements ClientProfileOpener {
  private readonly modalCtrl = inject(ModalController);

  async open(athleteId: number, options?: ClientProfileOpenOptions): Promise<void> {
    if (!athleteId) return;

    const modal = await this.modalCtrl.create({
      component: LibClient360Component,
      componentProps: {
        athleteId: signal(athleteId),
        defaultSegment: signal(options?.defaultSegment ?? 'summary'),
      },
      cssClass: 'client-360-modal modal-fullscreen',
    });

    await modal.present();
  }
}
